<template>
  <div class="print-no-overlap full-width-container bg-gray-300 py-7">
    <LazyOtherInfoForAgents
      v-if="trip?.product_manager"
      :key="trip.subtitle"
      :trip="trip"
    />
    <h4
      data-i18n="travelInfo"
      class="mb-7"
    >
      {{ $t('travelInfo') }}
    </h4>
    <template
      v-if="hasOtherInfo"
    >
      <div
        v-for="{ label, name, value, lang } in properties"
        :key="name"
        class="flex flex-col mb-3 last:mb-0"
      >
        <span
          class="other-info-label font-bold hidden sm:block"
          :data-i18n="lang"
        >{{ label }}</span>
        <strong class="block sm:hidden mr-4">
          {{ label }}
        </strong>
        <span
          class="font-secondary"
          :data-translation="trip?.[`${name}_translationkey`]"
        >
          {{ value }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(useRootStore, ['showTranslationTools']),

    properties () {
      return [
        {
          lang: 'tripIncluded',
          name: 'included_in_trip',
        },
        {
          lang: 'tripExtras',
          name: 'extras',
        },
        {
          lang: 'tripCurrency',
          name: 'currency',
        },
        {
          lang: 'tripSpecialInfo',
          name: 'special_info',
        },
      ]
        .map(prop => ({
          ...prop,
          label: this.$t(prop?.lang),
          value: this.trip?.[prop?.name],
        }))
        .filter(({ value }) => !!value)
    },

    hasOtherInfo () {
      return this.properties.length > 0
    },
  },
})
</script>
